import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChartBar, GraduationCap } from "@phosphor-icons/react";
import { useI18n } from "@/contexts/I18nContext";

// Completions-per-week-per-school sparkline (last 8 weeks) for board/school admins + SA.
export const CompletionsCard = () => {
  const { t } = useI18n();
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/completions-stats").then(r => setStats(r.data)).catch(() => setStats(null));
  }, []);
  if (!stats || !stats.schools?.length) return null;
  const max = Math.max(1, ...stats.schools.flatMap(s => s.counts));
  return (
    <div className="card mb-8" data-testid="completions-sparkline-card">
      <div className="flex items-center gap-2 mb-3">
        <ChartBar size={20} weight="duotone" color="#00A550" />
        <h3 className="text-lg font-bold font-display">{t("Course completions — last 8 weeks")}</h3>
      </div>
      <div className="flex flex-col gap-3">
        {stats.schools.map(s => (
          <div key={s.name} className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3" data-testid={`completions-row-${s.name}`}>
            <div className="sm:w-40 shrink-0 text-sm font-semibold truncate" title={s.name}>{s.name}</div>
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="flex items-end gap-1 h-10 flex-1 min-w-0">
                {s.counts.map((n, i) => (
                  <div key={i} className="flex-1 max-w-[26px] rounded-t"
                    title={`Week of ${stats.weeks[i]}: ${n} completion${n === 1 ? "" : "s"}`}
                    style={{ height: `${Math.max(8, (n / max) * 100)}%`, background: n ? "#00A550" : "#E4E4E7" }} />
                ))}
              </div>
              <div className="shrink-0 text-right">
                <div className="text-sm font-bold text-[#00A550] inline-flex items-center gap-1" title={`${s.total} total completions`}>
                  {s.total} <GraduationCap size={15} weight="fill" />
                </div>
                {s.fast_tracked > 0 && (
                  <div className="text-[10px] font-bold text-[#B45309]" data-testid={`fast-tracked-${s.name}`}
                    title="Completions granted via 'Pass all students' rather than finished organically">
                    {s.fast_tracked} {t("fast-tracked")}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-[11px] text-[#000000] mt-2">{t("Each bar is one week (oldest → newest).")}</div>
    </div>
  );
};
